import React from 'react';
import { createCommand, Option } from '@commander-js/extra-typings';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import type { CommandServices } from '@wix/cli-command-contract';
import { renderCommand, runCommand } from './render-command.js';

export const translationPullCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('pull')
    .description(
      'Pulls Wix Multilingual translations and saves them to your project directory'
    )
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format').hideHelp()
    )
    .action(async (opts, command) => {
      if (opts.json) {
        return runCommand(command, services, cliVersion, async (model) => {
          const { nonInteractiveTranslationPull } = await import(
            '../non-interactive/translation-pull.js'
          );
          return nonInteractiveTranslationPull(services, model);
        });
      }

      const { TranslationPullCommand } = await import(
        '../components/TranslationPullCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <TranslationPullCommand />
      );
    });
};
